import React, { lazy } from 'react';
import { LoadComponent, type RouteObject } from 'Routes/index';

const Documents = lazy(() => import('Pages/Screens/TaxClaimant/Documents/Page'));

const DocumentsRoutes = [
    {
        path: "documents",
        element: <LoadComponent component={Documents} />,
    },
]

export default DocumentsRoutes;